import React from "react";

const GroupedContainer = ({ className, children }) => {
  return (
    <div className={className + " flex flex-wrap justify-between gap-6  py-3"}>
      {/* This ensures the child items are responsive */}
      {children}
    </div>
  );
};

export default GroupedContainer;
